import { distinctUntilChanged } from 'rxjs/operators'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import { SUBMIT_BUTTON_CLICKED } from './registrationActions'
import { openWelcomeRegistrationModal } from './registrationActions'
import { setRegistrationWelcomePrompt } from 'aria-viewer/tour/tourActions'
import { Observable } from 'rxjs/Rx'

export default (action$, state$) => {
    // Observe when the welcome registration submit button was pressed
    return action$.ofType(SUBMIT_BUTTON_CLICKED).switchMap(_ => {
        // Then observe when the back button is clicked. At this point wph=1
        // has been pushed into history.
        return (
            action$
                .ofType('@@router/LOCATION_CHANGE')
                .distinctUntilChanged()
                // If we notice that wph is undefined - back button was pressed
                .filter(action => action.payload.query.wph === undefined)
                .mergeMap(_ => Observable.of(setRegistrationWelcomePrompt(true), openWelcomeRegistrationModal()))
        )
    })
}
